import { render } from "./confirmation-popup.vue?vue&type=template&id=4dfb879f&scoped=true"
import script from "./confirmation-popup.vue?vue&type=script&lang=js"
export * from "./confirmation-popup.vue?vue&type=script&lang=js"

import "./confirmation-popup.vue?vue&type=style&index=0&id=4dfb879f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfb879f"]])

export default __exports__